<template>
    <div class="row h-100 justify-content-center align-items-center bg-warning text-light">
        <div class="col-sm-8 col-11">
            <h1>Proyecto</h1>

            <p class="text-center">Muchas gracias.</p>

            <div class="row">
                <div class="col-sm-6">
                    <button class="btn w-100 btn-light btn-lg mt-4" @click="start()">Otro proyecto</button>
                </div>
                <div class="col-sm-6">
                    <button class="btn w-100 btn-light btn-lg mt-4" @click="start(true)">Salir</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from "../router";
import { mapActions } from "vuex";
export default {
    methods: {
        start(home = false) {
            this.clearProject();

            if (home) {
                router.push({ name: "First" });
                return;
            }
            router.push({ name: "Project1" });
        },
        ...mapActions(["clearProject"]),
    },
};
</script>
